import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';
import "./mail.css"

const Mail=(props)=>{
    const form = useRef();
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_ju8j39j', 'template_o3it9nh', form.current, 'PqrnlJc3ocaMiSdz_')
      .then((result) => {
          console.log(result.text);
      }, (error) => {
          console.log(error.text);
      });
  };
  return (
    <div className='mail-container'>
      <h1>Sending Mail</h1>
      <form ref={form} classname=""onSubmit={sendEmail}>
        <label>Name</label><br></br>
        <input type="text" value={props.name} name="from_name" /><br></br><br></br>
        <label>Email</label><br></br>
        <input type="email" name="from_email" /><br></br><br></br>
        <label>Message</label><br></br>
        <textarea name="message" /><br></br><br></br>
        <input type="submit" value="Send" /><br></br><br></br>
      </form>
    </div>
  );
}

export default Mail;